import Icon from '../components/Icon.vue'

Icon.register({
  'paint-roller': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M416 128V32C416 14.3 401.7 0 384 0H32C14.3 0 0 14.3 0 32V128C0 145.7 14.3 160 32 160H384C401.7 160 416 145.7 416 128zM448 64V192C448 209.7 433.7 224 416 224H256C220.7 224 192 252.7 192 288V320C174.3 320 160 334.3 160 352V480C160 497.7 174.3 512 192 512H256C273.7 512 288 497.7 288 480V352C288 334.3 273.7 320 256 320V288H416C469 288 512 245 512 192V128C512 92.6 483.4 64 448 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/paint-roller.js
// module id = MmbO
// module chunks = 144